import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpUtils} from "../shared/http.utils";
import {DefaultDecoderFilters} from "../model/filters/default-decoder-filters";
import {DefaultDecoderPersistRequest} from "../model/requests/default-decoder-persist-request";

@Injectable({
  providedIn: 'root'
})
export class DefaultDecodersService {

  private readonly defaultDecodersURL: string;

  constructor(private http: HttpClient) {
    this.defaultDecodersURL = "/catalog/default_decoders";
  }

  public getDefaultDecoders(offset?: number, limit?: number, filters?: DefaultDecoderFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new DefaultDecoderFilters();
    return this.http.post<any>(this.defaultDecodersURL, body, options);
  }

  public getDefaultDecoder(name: string): Observable<any> {
    const url = `${this.defaultDecodersURL}/${name}`;
    return this.http.get<any>(url);
  }

  public createDefaultDecoder(defaultDecoderCreationData: DefaultDecoderPersistRequest) {
    let url = `${this.defaultDecodersURL}/create`;
    return this.http.post<any>(url, defaultDecoderCreationData);
  }

  public editDefaultDecoder(defaultDecoderCreationData: DefaultDecoderPersistRequest) {
    let url = `${this.defaultDecodersURL}/edit`;
    return this.http.post<any>(url, defaultDecoderCreationData);
  }

  public deleteDefaultDecoder(name: string): Observable<HttpResponse<any>> {
    const url = `${this.defaultDecodersURL}/${name}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteDefaultDecoders(names: string[]) {
    let url = `${this.defaultDecodersURL}/delete`;
    return this.http.post<any>(url, names, {observe: 'response'});
  }

}
